export default __webpack_public_path__ + "static/ogp-c47831c05f1d58674165b7d09c3a6d44.jpg";